import { Box, Typography } from '@mui/material';
import WarningIcon from 'assets/icons/warning.svg';

import { styles } from './styles';

export const SelectAudienceErrorButton = () => {
  return (
    <Box sx={[styles.button, { cursor: 'default' }]}>
      <WarningIcon style={{ minHeight: '20px' }} />
      <Typography sx={[styles.buttonText, { color: '#ED4337' }]}>Something went wrong!</Typography>
    </Box>
  );
};
